export default "__VITE_ASSET__DqcGMiAH__"